export default __webpack_public_path__ + "static/media/okamelLogo.a6f5fab1.png";